module.exports = __webpack_public_path__ + "img/mariya_takeuchi.867a97bb.jpg";